const {root} = themeVars

function renderPosts() {

  const container = document.querySelector('[data-container]')
  const loadmoreBtn = container.parentElement.querySelector('[data-loadmore-btn]')
  const loadmoreBtnText = loadmoreBtn.textContent
  const countPosts = +container.dataset.count

  loadmoreBtn?.addEventListener('click', async () => {

    const btnContent = loadmoreBtn?.querySelector('[data-loadmore-btn-text]')
    const nextPage = ++container.dataset.currentPage

    btnContent.textContent = 'Loading'
    loadmoreBtn.classList.add('disabled')

    const response = await fetch(`${root}api/news?page=${nextPage}&count=${countPosts}`)
      .then(res => res.json())
      .catch((err) => console.error('request failed', err))

    response.posts.forEach(item => container.insertAdjacentHTML('beforeend', item))

    btnContent.textContent = loadmoreBtnText
    container.dataset.currentPage = nextPage
    loadmoreBtn.classList.remove('disabled')
    const isLastPage = container.dataset.currentPage >= container.dataset.totalPages

    loadmoreBtn.style.display = isLastPage ? 'none' : null
  })
}

renderPosts()
